export default {"src":"/_next/static/media/sync_opponent_ring.9266c107.svg","height":75,"width":75,"blurWidth":0,"blurHeight":0};